import * as React from 'react'
import { Container } from '../Container'
import { Carousel } from 'react-responsive-carousel'
import { StarsAndRatings } from './StarsAndRatings'
import { GraySection } from '../GraySection'
import viocLogo from '../../../public/img/vioc-logo.png'
import googleLogoIcon from '../../../public/img/icons/google-logo-icon.png'
import Image from 'next/image'

export const ReviewsSection: React.FC<{
  first: ReviewProps
  second: ReviewProps
  third: ReviewProps
  title: string
  partnerLabel?: string
  reviewCountLabel?: string
}> = ({
  first,
  second,
  third,
  title,
  partnerLabel = 'PREFERRED BRAKE PARTNER',
  reviewCountLabel = '(14,270 reviews)',
}) => {
  return (
    <GraySection className="xl:py-20">
      <Container>
        <div className="flex items-center justify-center mb-6">
          <Image
            src={viocLogo}
            width={50}
            height={45.56}
            objectPosition="bottom center"
            priority={true}
            alt="Valvoline logo"
          />
          <span className="ml-4 text-sm lg:text-base" style={{ fontFamily: 'IndustryInc-Base' }}>
            {partnerLabel}
          </span>
        </div>
        <div className="text-center pb-5">
          <h2 className="title text-2xl sm:text-3xl md:text-4xl">{title}</h2>
          <div className="flex mt-4 justify-center items-center text-black flex-wrap">
            <span className="mr-3" style={{ fontFamily: 'IndustryInc-Base' }}>
              4.9
            </span>
            <StarsAndRatings />
            <div className="flex ml-3 items-center">
              <div>{reviewCountLabel}</div>
              <div className="ml-2 flex items-center justify-center w-5 h-5 rounded-full">
                <Image src={googleLogoIcon} objectPosition="bottom center" priority={true} alt="Valvoline logo" />
              </div>
            </div>
          </div>
        </div>
        <div className="md:hidden">
          <Carousel showThumbs={false} showStatus={false} showArrows={false} autoPlay={true} infiniteLoop={true}>
            <V2Review {...first} />
            <V2Review {...second} />
            <V2Review {...third} />
          </Carousel>
        </div>
        <div className="hidden md:grid md:grid-cols-3 gap-4">
          <div>
            <V2Review {...first} />
          </div>
          <div>
            <V2Review {...second} />
          </div>
          <div>
            <V2Review {...third} />
          </div>
        </div>
      </Container>
    </GraySection>
  )
}

type ReviewProps = {
  review: string
  reviewer: string
}

export const V2Review: React.FC<ReviewProps> = ({ review, reviewer }) => {
  return (
    <div style={{ marginBottom: 40 }} className="flex flex-col h-100">
      <div
        style={{
          border: '1px solid #dcdbdb',
        }}
        className="flex flex-col px-4 py-5 h-100 bg-white"
      >
        <p>{`"${review}"`}</p>
        <div className="flex w-full items-center">
          <p style={{ fontFamily: 'IndustryInc-Base' }} className="reviewer my-auto text-sm leading-none pr-3 mr-auto">
            {reviewer}
          </p>
          <StarsAndRatings />
        </div>
      </div>
    </div>
  )
}
